import React, { FC } from 'react';

const IconPencil: FC = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 20 18"
      className="icon-medium"
      {...props}
    >
      <g
        fill="none"
        fillRule="evenodd"
        strokeWidth="1.12"
        transform="translate(1.243 1.07)"
      >
        <path
          strokeLinecap="round"
          d="M2.27805461,10.2860087 C1.9323764,10.6015029 1.52191166,11.2053128 1.35608656,11.6484708 L-0.146081441,15.6629283 C-0.199414651,15.8054582 -0.119036398,15.9140761 0.0405372687,15.905136 L3.90974518,15.6883638 C4.37824815,15.662116 5.04446281,15.3994788 5.40014945,15.0997484 L17.2444915,5.11874402 C17.5991161,4.81990856 17.6511355,4.28407643 17.3616224,3.92310411 L14.4582246,0.303074742 C14.1682896,-0.058423484 13.6536681,-0.0963056722 13.3073451,0.219777046 L2.27805461,10.2860087 Z"
        />
        <line x1="10.882" x2="14.639" y1="2.721" y2="7.322" />
      </g>
    </svg>
  );
};

export default IconPencil;
